import { track } from "@vercel/analytics";

const safeTrack = (eventName, payload = {}) => {
  try {
    track(eventName, payload);
  } catch {
    // analytics must never break UX
  }
};

export const trackContactFormSubmit = (success) => {
  safeTrack("contact_form_submit", { success });
};

export const trackProjectClick = (projectName) => {
  safeTrack("project_click", { project: projectName });
};

export const trackToolClick = (toolName) => {
  safeTrack("tool_click", { tool: toolName });
};

export const trackTestimonialView = (author) => {
  safeTrack("testimonial_view", { author });
};

export const trackSocialLinkClick = (platform) => {
  safeTrack("social_link_click", { platform });
};

export const trackCtaClick = (label) => {
  safeTrack("cta_click", { label });
};
